//const slider = new Swiper(".slider", {
//  //navigation: {
//  //  nextEl: ".swiper-button-next",
//  //  prevEl: ".swiper-button-prev",
//  //},
//  //effect: 'fade',
//  autoplay: {
//    delay: 6000,
//  },
//  loop: true,
//  navigation: {
//    nextEl: ".swiper-button-next",
//    prevEl: ".swiper-button-prev",
//  //},
//  //thumbs: {
//  //  swiper: sliderThumbnail
//  }
//});
//
//// thumbnailを追従させたくないので、slideToメソッドでサムネイルと連動
//function thumbnail(index) {
//  slider.slideTo(index);
//}
//サムネイル
var sliderThumbnail = new Swiper('.slider-thumbnail', {
  slidesPerView: 3,
  freeMode: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  slidesPerView: 'auto',
});

//スライダー
var slider = new Swiper('.slider', {
  loop: true,
  autoplay: {
    delay: 6000,
  },
  thumbs: {
    swiper: sliderThumbnail,
  },
});
